import { render } from "./index.vue?vue&type=template&id=6d53819e"
const script = {}

import exportComponent from "D:\\yuntian\\eso\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__